import { Milestone } from "../../types/goals";
import MilestoneItem from "./MilestoneItem";

interface MilestonesTabContentProps {
    milestones: Milestone[];
    currentMilestone: Milestone | undefined;
    getMilestoneProgress: (milestoneId: string) => number;
    onMilestoneClick: (milestoneId: string) => void;
}
const MilestonesTabContent = ({ milestones, currentMilestone, getMilestoneProgress, onMilestoneClick }: MilestonesTabContentProps) => {
    const sortedMilestones = [...milestones].sort((a, b) => a.order - b.order);

    return (
        <div className="space-y-4">
            {sortedMilestones.map((milestone) => (
                <MilestoneItem
                    key={milestone._id}
                    milestone={milestone}
                    isCurrent={currentMilestone?._id === milestone._id}
                    progress={getMilestoneProgress(milestone._id)}
                    onClick={() => onMilestoneClick(milestone._id)}
                />
            ))}
        </div>
    );
};

export default MilestonesTabContent;